import FetchIt from "./FetchIt"

const create_case = new FetchIt('/case/create-case/')
const purpose_details = new FetchIt("/case/purpose-details/")
const case_list = new FetchIt("/case/get-case-list/")
const cal_interest = new FetchIt("/case/update-calculate-interest/")


const Case = {
    getMany: ({ params, body }) => case_list.post({ params, body }),
    getDraft: () => case_list.post({ body: { status: "draft" } }),
    getPurposeFields: ({ params, display_label }) => purpose_details.get({ params: { ...params, display_label } }),
    create: ({ body }) => create_case.post({ body }),
    put_interest: ({ case_id, body }) => cal_interest.post({ url: cal_interest.url + case_id + '/', body }),
    get_interest: ({ case_id }) => cal_interest.get({ url: cal_interest.url + case_id + '/' })
}

const user_reg = new FetchIt("/user/register-user/")
const benefactor_list = new FetchIt("/user/get-benefactor-list")
const Benefactor = {
    register: ({ body }) => user_reg.post({ body }),
    getMany: () => benefactor_list.get()
}


const update_repayment = new FetchIt('/case/update-repayment/')

const Repayment = {
    create: ({ payload, case_id }) => update_repayment.put({ body: payload, url: update_repayment.url + case_id + '/' })
}


const upload = new FetchIt('/case/upload/')
const File = {
    upload: ({ body }) => upload.post({ body })
}

const Admin = { Case, Benefactor, Repayment, File }

export default Admin